export default class VisibilityListCtrl {
  constructor ($scope, $stateParams, $timeout, WorkPlanSrv, WorkPlanModalSrv, GlobalConfig, $cookies, $state, $mdDialog, $filter, Requests, $sessionStorage) {
// constants
    const visibilityVM = this
    const listUser = JSON.parse($cookies.get('currentUser'))
    let post = {
      teacherId: listUser.teacherId,
      workplanId: listUser.workplanId
    }


  // variables
    visibilityVM.showData = false
    visibilityVM.viewLoaded = false
    visibilityVM.criteriaFilter = ''
    visibilityVM.selectedProject = null
    visibilityVM.detailsData = null
    visibilityVM.listVisibility = []
    visibilityVM.imgEmpty = require('../../../../../../assets/images/empty_state_illustration.svg')
    visibilityVM.sr = ''
    visibilityVM.searchValue = false
    visibilityVM.feedback = 0
    visibilityVM.planningFinish = true
    $scope.classPlanning = ''
    visibilityVM.active = GlobalConfig.generals.active
    visibilityVM.notActive = GlobalConfig.generals.notActive
    visibilityVM.isMedia = false
    visibilityVM.isEvent = false
    visibilityVM.isNetwork = false
    visibilityVM.workPlanGeneralList = $sessionStorage.workPlanGeneralList
    visibilityVM.$sessionStorage = $sessionStorage

  // methods
    visibilityVM.details = details
    visibilityVM.updateSearchView = updateSearchView
    visibilityVM.tagClas = tagClass
    visibilityVM.visibilityBckgrd = visibilityBckgrd
    visibilityVM.visibilityText = visibilityText
    visibilityVM.getReviewData = getReviewData
    visibilityVM.close = close
    visibilityVM.confirmDeleteVisibility = confirmDeleteVisibility
    visibilityVM.thereIsDetails = thereIsDetails
    visibilityVM.updateFilter = updateFilter
    visibilityVM.getGeneralsWorkplan = getGeneralsWorkplan
    visibilityVM.bitacora = bitacora


    angular.extend(visibilityVM, {
      isLoadingDetails : false,
      filter:''
    })
  
    activate()

    function activate () {
      if(visibilityVM.workPlanGeneralList != undefined){
        visibilityVM.status = visibilityVM.workPlanGeneralList.wokplanTeacherStatus[0]
        visibilityVM.stages = visibilityVM.workPlanGeneralList.stages
        visibilityVM.feedback = visibilityVM.status.feedbackReviewed
        visibilityVM.workplanTeacherId = visibilityVM.status.workplanTeacherId
        isPlanning(visibilityVM.status, visibilityVM.stages)
      
        if(visibilityVM.feedback && !visibilityVM.planningFinish){
          getReviewDataReject()
        }else{
          getReviewData()
        } 
      }else{
        getGeneralsWorkplan(post).then((promise) => {
          if(visibilityVM.feedback && !visibilityVM.planningFinish){
            getReviewDataReject()
          }else{
            getReviewData()
          }
        })
      }
    }

    function getReviewData () {

      WorkPlanSrv.getListVisibilityActivities.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            visibilityVM.listVisibility = dataReturn.listVisibilityActivities
            if(visibilityVM.listVisibility.length == 0){
              visibilityVM.detailsData = true
            }


            for (var i = visibilityVM.listVisibility.length - 1; i >= 0; i--) {
              if (visibilityVM.listVisibility[i].activityTypeId == GlobalConfig.typeProject.internal){
                visibilityVM.listVisibility[i].activityTypeName = 'Proyecto Interno'
              }else{
                visibilityVM.listVisibility[i].activityTypeName = 'Proyecto Transversal'
              }
            }

            if(visibilityVM.listVisibility && visibilityVM.listVisibility.length > 0)
              visibilityVM.details(visibilityVM.listVisibility[0])
          }else{
            console.log("Comunications problem")
          }
        },
        data => {
          console.log()
        }
      )
    }

    function getReviewDataReject () {

      WorkPlanSrv.getListVisibilityActivitiesReject.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            visibilityVM.listVisibility = dataReturn.listVisibilityActivities
            if(visibilityVM.listVisibility.length==0){
              visibilityVM.detailsData = true
            }
            
            if(visibilityVM.listVisibility.length == 0)
              visibilityVM.detailsData = 0

            for (var i = visibilityVM.listVisibility.length - 1; i >= 0; i--) {
              if (visibilityVM.listVisibility[i].activityTypeId == GlobalConfig.typeProject.internal){
                visibilityVM.listVisibility[i].activityTypeName = 'Proyecto Interno'
              }else{
                visibilityVM.listVisibility[i].activityTypeName = 'Proyecto Transversal'
              }
            }

            if(visibilityVM.listVisibility && visibilityVM.listVisibility.length > 0)
              visibilityVM.details(visibilityVM.listVisibility[0])
          }else{
            console.log("Comunications problem")
          }
        },
        data => {
          console.log()
        }
      )
    }

    function getvisibilitysDetails (visibilitys, reload = false, callback) {
      WorkPlanSrv.getVisibilityActivitiesById.get({workplanTeacherActivityId: visibilitys.workplanTeacherActivityId}).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            visibilityVM.detailsData = dataReturn.listVisibility[0]
            //visibilityVM.detailsData.startDate = moment(visibilityVM.detailsData.startDate).format('DD/MM/YYYY')
            //visibilityVM.detailsData.endDate  = moment(visibilityVM.detailsData.endtDate).format('DD/MM/YYYY')
            validateTypeVisibility(visibilityVM.detailsData.nameCommunicationRegister)
          }else{
            console.log("Comunications problem")
          }
        },
        data => {
          console.log()
        }
      )
      
      if (!reload) {
        visibilityVM.isLoadingDetails = true
        visibilityVM.detailsData = null
      }
      callback
    }

    function thereIsDetails () {
      return Boolean(visibilityVM.detailsData)
    }

    function tagClass (visibility) {
        return 'azul'
    }

    function visibilityBckgrd (visibility) {
      if (visibilityVM.selectedProject === visibility) {
        return 'bg-review'
      }
    }

    function visibilityText (visibility) {
      if (visibilityVM.selectedProject === visibility) {
        return 'text-color-w'
      }
    }

    function details (visibility) {
      visibilityVM.detailsData = null
      visibilityVM.selectedProject = visibility
      visibilityVM.isLoadingDetails = true
      getvisibilitysDetails(visibility, function(){
        visibilityVM.isLoadingDetails = false
      })
    }

    function close(){
      return $mdDialog.hide()
    }

    function updateSearchView () {
      visibilityVM.viewLoaded = true
      visibilityVM.viewLoaded = false
      $timeout(() => {
        visibilityVM.viewLoaded = true
      }, 100)
    }

    function confirmDeleteVisibility (visibility) {   
      let name = visibility.nameVisibility
      let workplanTeacherActivityId = visibility.workplanTeacherActivityId
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
          let ctrlModalVM = this
          ctrlModalVM.name = name
          ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId
          ctrlModalVM.close = function () {
            $mdDialog.hide()
          }
          ctrlModalVM.delete = function () {
            WorkPlanSrv.disableActivityResearch.delete({workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId})
            .$promise.then(function (dataReturn) {
              if (dataReturn.status) {
                removeFromlist(visibility)
                showDeletedSuccessfully(ctrlModalVM.name)
                $mdDialog.hide()
              } else {
                console.log('Comunications problem with the server')
              }
            }, function (data) {

            })
            
          }
        }],
        controllerAs: 'ctrlModalVM',
        template: require('./deleteModal.html'),
        clickOutsideToClose: false
      })
    }

    function showDeletedSuccessfully(name){
      let texts = GlobalConfig.appTexts
      let header = {
        createOrEdit     : texts.deleteDialog,
        textCreateOrEdit : texts.deleted,
        itemName         : name,
        nameModal        : texts.modalTypeName.deleted,
        modalType        : texts.modalTypeId.default
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })      
    }
    
    function removeFromlist(visibility){
      for(var i in visibilityVM.listVisibility){
        if(visibilityVM.listVisibility[i].workplanTeacherActivityId === visibility.workplanTeacherActivityId){
          visibilityVM.listVisibility.splice(i,1)
        updateSearchView()
          break
        }
      }
    }

    function getGeneralsWorkplan(post){
      return WorkPlanSrv.getElementsRightBar.getList({teacherId: post.teacherId}).$promise.then(function(dataReturn) {
        if(dataReturn.status){
          visibilityVM.$sessionStorage.workPlanGeneralList = dataReturn.data
          visibilityVM.status = dataReturn.data.wokplanTeacherStatus[0]
          visibilityVM.stages = dataReturn.data.stages
          visibilityVM.feedback = visibilityVM.status.feedbackReviewed
          visibilityVM.workplanTeacherId = visibilityVM.status.workplanTeacherId
          isPlanning(visibilityVM.status, visibilityVM.stages)
        }else{
          console.log("Comunications problem with the server")
        }
      },function(data) {
           console.log(data);
      })
    }

    function isPlanning(status, stages){
      visibilityVM.currentDate = moment(new Date()).format("DD/MM/YYYY")
      for (var i = stages.length - 1; i >= 0; i--) {
        if(stages[i].stageId == GlobalConfig.workplanIdStages.review){
          visibilityVM.startDateStage = stages[i].startDate
        }
      }

      if(status.workplanActive){
        if (status.planningFinish == visibilityVM.active){        
          visibilityVM.planningFinish = true
          if (visibilityVM.startDateReview < visibilityVM.currentDate || status.reviewedFinish == visibilityVM.active){
            visibilityVM.planningFinish = true
          }else if (status.reviewedReject == visibilityVM.active){
            visibilityVM.planningFinish = false
          }
        } else {
            visibilityVM.planningFinish = false
        }
      }else{
        visibilityVM.planningFinish = true
      }

      $scope.classPlanning = (visibilityVM.planningFinish ? "disabled" : " ")
    }

    function updateFilter (val) {
      visibilityVM.sr = validateSearch()
      if (visibilityVM.sr.length == 0){
        visibilityVM.searchValue = true
        visibilityVM.detailsData = null
      }else{
        visibilityVM.searchValue = false
        if(visibilityVM.listVisibility && visibilityVM.listVisibility.length > 0)
          visibilityVM.details(visibilityVM.listVisibility[0])
      }
    }

    function validateSearch() {
      return $filter('filter')(visibilityVM.listVisibility, visibilityVM.criteriaFilter)
    }

    function validateTypeVisibility(strVal){
      strVal = strVal.substring(0, 3);
      //si es medio de comunicacion
      if (strVal == 'Med'){
        visibilityVM.isMedia = true
        visibilityVM.isEvent = false
        visibilityVM.isNetwork = false
      //si es eventos
      } else if (strVal == 'Org'){
        visibilityVM.isEvent = true
        visibilityVM.isMedia = false
        visibilityVM.isNetwork = false
      //si es redes
      } else if (strVal == 'Red'){
        visibilityVM.isNetwork = true
        visibilityVM.isMedia = false
        visibilityVM.isEvent = false
      }

    }

    function bitacora (ev) {
      let entries = {}

      entries.params = {
        activityTypeId: GlobalConfig.activityTypeId.visibility,
        workplanTeacherId: visibilityVM.workplanTeacherId
      }
      entries.title = 'Comunicación y visibilidad'
      // Entries(this.entries);
      entries.data = undefined
      $mdDialog.show({
        controller: 'bitacoraModalCtrl',
        controllerAs: 'bit',
        template: require('../../../../strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModal.html'),
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {data: entries},
        clickOutsideToClose: true,
        fullscreen: true
      })
    }

  }
  
}

VisibilityListCtrl.$inject = ['$scope', '$stateParams', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', 'GlobalConfig', '$cookies', '$state', '$mdDialog', '$filter', 'Requests', '$sessionStorage']




// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/extensionVisibility/visibility/list/visibilityListCtrl.js